import { useEffect, useState } from "react";
import axios from "axios";

const CORES = {
  homologacao: { fundo: "#b45309", texto: "#fff", rotulo: "HOMOLOGAÇÃO" },
  local:       { fundo: "#1d4ed8", texto: "#fff", rotulo: "LOCAL" },
};

export default function FaixaAmbiente() {
  const [ambiente, setAmbiente] = useState(null);

  useEffect(() => {
    const base = process.env.REACT_APP_API_URL || "";
    axios.get(`${base}/api/config/`).then(r => setAmbiente(r.data.ambiente)).catch(() => {});
  }, []);

  if (!ambiente || ambiente === "producao") return null;

  const cor = CORES[ambiente] || { fundo: "#374151", texto: "#fff", rotulo: ambiente.toUpperCase() };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        background: cor.fundo,
        color: cor.texto,
        textAlign: "center",
        fontSize: "0.7rem",
        fontWeight: "700",
        letterSpacing: "0.12em",
        padding: "3px 0",
        userSelect: "none",
      }}
    >
      AMBIENTE DE {cor.rotulo} — NÃO USE PARA OPERAÇÃO REAL
    </div>
  );
}
